import getApi from '../../../api'
import { SephiraToken } from '../../../model/Sephira'

export const generateSephiraToken = () =>
  getApi().get<SephiraToken>(`/external-services/sephira/token`)
